import { createStyles, rem } from '@mantine/core'

import { DoctorCardDisplay } from '.'

export interface StylesParams {
  display: DoctorCardDisplay
}

export default createStyles((_theme, params: StylesParams) => {
  const { display } = params
  return {
    root: {
      display: 'flex',
      background: 'white',
      borderRadius: rem(16),
      boxShadow:
        '0px 0px 1px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px 0px rgba(0, 0, 0, 0.06)',
      ...(display === 'vertical'
        ? {
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            gap: rem(0),
          }
        : {}),
    },
    avatar: {
      position: 'relative',
      borderTopLeftRadius: 'inherit',
      ...(display === 'vertical'
        ? {
            borderTopRightRadius: 'inherit',
          }
        : {
            borderBottomLeftRadius: 'inherit',
            width: rem(240),
            height: rem(240),
          }),
    },
    info: {
      ...(display === 'vertical' && {
        padding: `${rem(12)} ${rem(16)}`,
      }),
    },
    btn: {
      ...(display === 'vertical'
        ? {
            width: '100%',
          }
        : {
            minWidth: rem(132),
          }),
    },
  }
})
